import { checkUserToken, UserManager, startTokenOrSignin, getAccessTokenOrSignin, setRedirectPage, logoutLocal } from '../lib/OidcHelper';
import { isMode, messageBoxAnswerWait, TripPlannerMode, askForItineraries, isSandboxMode } from "./TripPlannerHelper";

const componentValues = {
  // initial componentValues
  itineraryQueue: [],
  debounceTime: 0,
  productDetail: {},
  productDetails: [],
  saveGeneration: 0,
  hasOidc: false,
  sandboxItinery: [],
  oidcUserManager: null,
  apiHubUrl: '',
  itineraryPayload: null,
};

async function initAddToTripCardBtnListeners() {
  // (re-)create on click listeners on new cards.
  // Namespaced events so re-running this (page updates, multiple itinerary modules,
  // post-login re-init) replaces the previous handlers instead of stacking them -
  // .off('click', fn) with a freshly-created fn never matched, so handlers accumulated
  // and one click could fire the modal logic multiple times.
  $('.js-openModalButton')
    .off('click.addtotrip')
    .on('click.addtotrip', (evt) => openModalLogic(evt));  // button on product page

  const clickAction = (evt) => {
    console.log('click-!');
    openModalLogic(evt);
    $('.tripmodal__save-bottom').css('display', 'none'); // reset Save button
  };

  $('.js-addtotrip-btn')
    .off('click.addtotrip')
    .on('click.addtotrip', clickAction);

}



async function openModalLogic(evt) { // Add-to-trip button clicked
  evt.preventDefault();
  console.log('AAA openModalLogic called');
  getProductDetail(evt); // and store in componentValues.productDetail

  const product = getProduct(evt);
  componentValues.productDetails = [product];
  await openModalForProducts(componentValues.productDetails);
}


async function openModalForProducts(products) {
  componentValues.itineraryPayload = null;
  sessionStorage.removeItem('pendingItineraryPayload');

  const uniqueProducts = Array.from(new Map(
    (products || [])
      .filter(product => product && product.Id)
      .map(product => [String(product.Id), product])
  ).values());

  if (uniqueProducts.length === 0) {
    return;
  }

  componentValues.productDetails = uniqueProducts;
  componentValues.productDetail = uniqueProducts[0];

  const product = uniqueProducts[0];
  await runAnalyticsAction("trip_action", "add to trip", componentValues.itineraryQueue, product);

  // Check what tpMode we are in and if we need to sign in
  if (isMode('')) {
    const answer = await messageBoxAnswerWait();
    if (!answer)
      return;
  }
  if (isMode(TripPlannerMode.sandbox)) {
    // Get itineraries from iframe and add to window.usersTrips
    await askForItineraries().then(() => {
      drawModalTrips(window.usersTrips);
      $('#addToTripModal').modal('show');
    });
    return;
  }

  // Save in session storage for after the auth redirect
  sessionStorage.setItem('modalOpen_Add', JSON.stringify(product));
  sessionStorage.setItem('modalOpen_Add_Products', JSON.stringify(uniqueProducts));

  console.log('check User Token');
  const token = checkUserToken();

  // check if user is logged in
  // const token = await getAccessTokenOrSignin(thisComponent.oidcUserManager);
  if (token === null) {
    console.log('no token.');
    sessionStorage.removeItem('signinPageVisited');
    // send user to login and display AddToTripModal

    const { oidcUserManager, token: refreshedToken } = await startTokenOrSignin();

    // If signinRedirect was triggered, the page has navigated away and execution
    // stops here. On return, AddToTripModal.load() reopens the modal via the
    // sessionStorage flags. If we got a token back instead (valid OIDC session,
    // no redirect needed), open the modal now — the legacy code missed this path.
    if (refreshedToken) {
      localStorage.setItem('user_token', refreshedToken);
      $('#addToTripModal').modal('show');
      initModal();
    }

  } else {
    // got a token so show addtotrip modal.
    $('#addToTripModal').modal('show');

    initModal();
  }
}


function getProductDetail(evt) {
  // Buttons contain child icons (<i>/<svg>/<span>), so evt.target can be a
  // child without the data attributes. Walk up to the element carrying productid.
  const target = $(evt.target).closest('[productid]');

  componentValues.productDetail.Id = target.attr('productid');
  componentValues.productDetail.Name = target.attr('productname');
  componentValues.productDetail.Type = target.attr('producttype');
  componentValues.productDetail.Location = target.attr('productlocation');
}


function getProduct() {
  let tripObj = {};
  const productOnPage = document.getElementById("contactAddress");

  // If on product page get product details
  if (productOnPage) {
    tripObj.Id = productOnPage?.getAttribute('productid');
    tripObj.Name = productOnPage?.getAttribute('productname');
    tripObj.Type = productOnPage?.getAttribute('producttype');
    tripObj.Location = productOnPage?.getAttribute('productlocation');
    return tripObj;
  }
  // If from search results get product details
  else if (componentValues.productDetail && Object.keys(componentValues.productDetail).length > 0) {
    tripObj.Id = componentValues.productDetail.Id;
    tripObj.Name = componentValues.productDetail.Name;
    tripObj.Type = componentValues.productDetail.Type;
    tripObj.Location = componentValues.productDetail.Location;
    return tripObj;
  }

  const storedProduct = sessionStorage.getItem('modalOpen_Add');
  if (storedProduct) {
    tripObj = JSON.parse(storedProduct);
  }

  return tripObj;
}


function getProducts() {
  if (componentValues.productDetails.length > 0) {
    return componentValues.productDetails;
  }

  const storedProducts = sessionStorage.getItem('modalOpen_Add_Products');
  if (storedProducts) {
    try {
      const products = JSON.parse(storedProducts);
      if (Array.isArray(products) && products.length > 0) {
        componentValues.productDetails = products;
        return products;
      }
    } catch (error) {
      console.warn('Unable to restore products for Add to Trip.', error);
    }
  }

  const product = getProduct();
  return product && product.Id ? [product] : [];
}



async function runAnalyticsAction(actionId, actionName, itineraryQueue, product) {
  //Initializing the data layer on the window object which already exist
  window.digitalData = window.digitalData || [];
  window.digitalData.account = {};
  window.digitalData.trip = [];
  window.digitalData.tripAction = actionName;

  let user = null;
  if (componentValues.oidcUserManager !== null) {
    user = await componentValues.oidcUserManager.getUser();
  } else {
    console.warn('runAnalyticsAction: oidcUserManager is null.');
  }

  if (user && user.profile) {
    window.digitalData.account.ID = user.profile.sub;
  }

  if (typeof itineraryQueue !== 'undefined' && itineraryQueue.length > 0) {
    itineraryQueue.forEach(id => {
      let tripObj = {};
      const currentRegion = product?.Location;

      const trip = window.usersTrips.find(x => x.id === id);

      tripObj.tripID = id
      if (typeof trip !== 'undefined') {
        tripObj.tripName = trip.name;

        if (typeof trip.regions !== 'undefined' && trip.regions.length > 0) {
          tripObj.regionName = getRegions(trip.regions, currentRegion);
        } else {
          tripObj.regionName = currentRegion;
        }
      } else {
        tripObj.tripName = 'New Trip'
        tripObj.regionName = currentRegion;
      }

      if (product) {
        tripObj.productID = product.Id;
        tripObj.productName = product.Name;
        tripObj.productLocation = product.Location;
        tripObj.productType = product.Type;
      }

      window.digitalData.trip.push(tripObj);
    });
  } else if (product) {
    const tripObj = {};

    tripObj.productID = product.Id;
    tripObj.productName = product.Name;
    tripObj.productLocation = product.Location;
    tripObj.productType = product.Type;

    window.digitalData.trip.push(tripObj);
  }

  trackIfNotLocal(actionId);
}


async function initModal() {

  setRedirectPage();

  componentValues.itineraryQueue = []; // reset Queue
  $('.tripmodal__save-bottom').css('display', 'none'); // reset Save button


  // when Modal opens fetch itineraries from API but not too often
  const theTime = Date.now();

  if (isSandboxMode()) {
    await askForItineraries();


    // TODO: if couldn't get itineraries then show error message


  } else if (theTime - componentValues.debounceTime > 1000) { // don't fetch again unless time has passed
    window.usersTrips = await getItineraries();
  }

  // store time for comparison next run
  componentValues.debounceTime = theTime;

  // check if getItineraries failed
  if (typeof window.usersTrips === 'string' && window.usersTrips === 'failed') {
    // Draw an error message
    return;
  }

  drawModalTrips(window.usersTrips);
}


function getRegions(regions, currentRegion) {
  // Need to add current region as there is no update to the products when new regions are added (saves an api call)
  if (currentRegion && typeof regions !== 'undefined' && !regions.includes(currentRegion)) {
    regions += `,${currentRegion}`;
  }
  if (!regions && currentRegion) {
    regions = currentRegion;
  }

  return regions;
}


function trackIfNotLocal(actionId) {
  if (!window.location.hostname.includes('local')) {
    if (window._satellite && typeof window._satellite.track === 'function') {
      window._satellite.track(actionId);
    }
  } else {
    console.log('analytics run');
  }
}


function drawModalTrips(itineraries) {
  const cardFragment = [];
  if (itineraries && itineraries.length > 0) {
    itineraries.forEach(trip => {
      const id = trip.id;
      const name = trip.name;
      const days = trip.dayCount ? trip.dayCount : 0;
      // placeholder image should never be needed, as a trip can't exist without 1 stop
      const placeholder = 'https://umsaprod.blob.core.windows.net/trip-planner/adelaide-1.jpg';
      const qsSeparator = trip.imageUrl[0] && trip.imageUrl[0].includes('?') ? '&' : '?';
      const fullCrop = qsSeparator + 'w=220&h=110&fit=crop'; //ATDW undocumented cropping
      const halfCrop = qsSeparator + 'w=110&h=110&fit=crop';
      const thirdCrop = qsSeparator + 'w=110&h=55&fit=crop';

      let image1Url = trip.imageUrl[0] ? trip.imageUrl[0] : placeholder;
      let image2Url = '';
      let image3Url = '';
      let column2 = '';

      if (trip.imageUrl.length === 1) {
        // one image provided
        image1Url += fullCrop;
      } else if (trip.imageUrl.length === 2) {
        // two images provided
        image1Url += halfCrop;
        image2Url = trip.imageUrl[1] + halfCrop;
        column2 = `<div class="col">
            <div class="row">
              <img class="trip-card__image trip-card__image--large border-round-left" src="${image2Url}" alt="">
            </div>
          </div>`;
      } else if (trip.imageUrl.length === 3) {
        // three images provided
        image1Url += halfCrop;
        image2Url = trip.imageUrl[1] + thirdCrop;
        image3Url = trip.imageUrl[2] + thirdCrop;
        column2 = `<div class="col">
            <div class="row">
              <img class="trip-card__image trip-card__image--small border-round-left" src="${image2Url}" alt="">
            </div>
            <div class="row">
              <img class="trip-card__image trip-card__image--small border-round-left" src="${image3Url}" alt="">
            </div>
          </div>`;
      }

      const stops = trip.stopCount ? trip.stopCount : 0;
      const description = `${days} days<br>&nbsp;${stops} stops`;

      cardFragment.push(`<div class="col-6 col-md-4 modalcard-col trip-card__wrapper">
          <div class="card trip-card" data-trip-id="${id}">
            <div class="container">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <img class="trip-card__image trip-card__image--large border-round-right" src="${image1Url}" alt="">
                  </div>
                </div>
                ${column2}
              </div>
              <div class="img-overlay">
                <div class="img-overlay__background"></div>
                <button type="button" class="btn btn-secondary img-btn-overlay">
                  ADD TO TRIP
                </button>
              </div>
            </div>
            <div class="card-body trip-card-body">
              <div class="container">
                <div class="row">
                  <p class="trip-card-title">${name}</p>
                </div>
                <div class="row">
                  <p class="trip-card-description">${description}</p>
                </div>
              </div>
            </div>
            <div class="trip-card-overlay">
              <div class="container">
                <div class="row trip-card-overlay__row trip-card-overlay__icon-container">
                  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                    <path d="M40 14C46.8956 14 53.5088 16.7393 58.3848 21.6152C63.2607 26.4912 66 33.1044 66 40C66 46.8956 63.2607 53.5088 58.3848 58.3848C53.5088 63.2607 46.8956 66 40 66C33.1044 66 26.4912 63.2607 21.6152 58.3848C16.7393 53.5088 14 46.8956 14 40C14 33.1044 16.7393 26.4912 21.6152 21.6152C26.4912 16.7393 33.1044 14 40 14ZM40 72C48.4869 72 56.6263 68.6286 62.6274 62.6274C68.6286 56.6263 72 48.4869 72 40C72 31.5131 68.6286 23.3737 62.6274 17.3726C56.6263 11.3714 48.4869 8 40 8C31.5131 8 23.3737 11.3714 17.3726 17.3726C11.3714 23.3737 8 31.5131 8 40C8 48.4869 11.3714 56.6263 17.3726 62.6274C23.3737 68.6286 31.5131 72 40 72ZM54.125 34.125C55.3 32.95 55.3 31.05 54.125 29.8875C52.95 28.725 51.05 28.7125 49.8875 29.8875L36.0125 43.7625L30.1375 37.8875C28.9625 36.7125 27.0625 36.7125 25.9 37.8875C24.7375 39.0625 24.725 40.9625 25.9 42.125L33.9 50.125C35.075 51.3 36.975 51.3 38.1375 50.125L54.125 34.125Z" fill="#FCF760"/>
                  </svg>
                </div>
                <div class="row trip-card-overlay__row ">
                  <p class="trip-card-overlay__description">Selected</p>
                </div>
              </div>
            </div>
          </div>
        </div>`);
    });
  }

  // the Modal needs
  // to count itineararies (if < 50 then add a "Create a new trip" button )
  if (!itineraries || (itineraries.length < 50 && !isSandboxMode()) || (itineraries.length === 0 && isSandboxMode())) {
    cardFragment.push(`<div class="col-6 col-md-4 modalcard-col trip-card__wrapper">
      <div class="card create-card">
        <div class="card-body create-card-body">
          <div class="container create-card-container">
            <div class="row create-card-row create-card-icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
                <path d="M16.2501 9.28125C16.2501 8.86562 15.9157 8.53125 15.5001 8.53125C15.0845 8.53125 14.7501 8.86562 14.7501 9.28125V14.2812H9.75012C9.3345 14.2812 9.00012 14.6156 9.00012 15.0312C9.00012 15.4469 9.3345 15.7812 9.75012 15.7812H14.7501V20.7812C14.7501 21.1969 15.0845 21.5312 15.5001 21.5312C15.9157 21.5312 16.2501 21.1969 16.2501 20.7812V15.7812H21.2501C21.6657 15.7812 22.0001 15.4469 22.0001 15.0312C22.0001 14.6156 21.6657 14.2812 21.2501 14.2812H16.2501V9.28125Z" fill="#FCF760"/>
              </svg>
            </div>
            <div class="row create-card-row">
              <p class="create-card-description">Add a new trip</p>
            </div>
          </div>

          <div class="trip-card-overlay">
            <div class="container">
              <div class="row trip-card-overlay__row trip-card-overlay__icon-container">
                <img src="/static/images/i_check_circle_light.svg" class="added_check_filter_color">
              </div>
              <div class="row trip-card-overlay__row ">
                <p class="trip-card-overlay__description">Add to trip</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>`);
  }
  // first clear old Trips from modal
  $('#trips-container').empty();
  $('#trips-container').append(cardFragment.join(""));

  console.log('call initAddToTripCardBtnListeners()');
  initAddToTripCardBtnListeners();
  initListeners();
}


async function getItineraries() {
  let itineraries = '';

  // GET All Itineraries with minimal detail
  const token = await getAccessTokenOrSignin(componentValues.oidcUserManager);
  if (!token) return [];

  const myHeaders = new Headers({
    'accept': 'text/plain',
    'Authorization': token
  });

  await fetch(`${componentValues.apiHubUrl}/api/Itinerary/GetMinimal`, {
    headers: myHeaders
  }).then(response => {
    if (!response.ok) {
      throw new Error(`Network response was not "ok". ${response.status}, ${response.statusText}`);
    }
    return response.json();
  }).then(data => {
    itineraries = data;
  }).catch(error => {
    //console.error('GET failed: ', error);
    console.warn('GET failed, e0001', error);
    if (error.status === 401) {
      console.error("Unauthorized. Need to reset session: ", error.status);
      //TODO: signOut();  // logoutLocal, close and re-init modal
    }
    // This is a fetch API error and not necesarily a login issue.
    itineraries = 'failed';
    // first clear old Trips from modal
    $('#trips-container').empty();
    const apiErrorMessage = `<div class="alert alert-danger" style="font-size: inherit;"><p>Failed to fetch from API. Please try and <a class="sa-signout" href="#">signout</a> and then signin again.</p>
        <p><small>${error}</small></p></div>`;
    $('#trips-container').append(apiErrorMessage);
    $('.sa-signout').on('click', signOut.bind(this));
  });

  return itineraries;
}


async function initListeners() {
  $('[data-trip-id]').on('click', onClickATrip.bind(this));
  $('.create-card').on('click', onClickCreate.bind(this));
}


async function signOut() {
  logoutLocal();  // delete logged in storage
  closeModal();
  // componentValues.oidcUserManager.signoutRedirect();  // logout of id-server
}


// Close Modal
function closeModal() {
  $('#addToTripModal').modal('hide');
  // now reset the buttons before next open
  $('.tripmodal__close-bottom').css('display', 'flex');
  $('.tripmodal__saving-message').css('display', 'none');
}


async function onClickATrip(e) {
  console.log("onClickATrip", e.target);
  const $target = $(e.currentTarget)

  alterItinerariesQueue($target.data('trip-id'), $target);

  // Show Added Overlay
  if ($target.find('.trip-card-overlay.show').length > 0) {
    $target.find('.trip-card-overlay').removeClass('show');
    $('.tripmodal__save-bottom').css('display', 'none');
  } else {
    $target.find('.trip-card-overlay').addClass('show');
    $target.find('.img-overlay').css('opacity', 0);
    $('.tripmodal__save-bottom').css('display', 'flex');
  }

  // Change word close to save
  $('.tripmodal__save').text('Save')
  // if (componentValues.itineraryQueue.length > 0) {
  //   console.log("itineraryQueue", componentValues.itineraryQueue.length);
  //   $('.tripmodal__save-bottom').css('display', 'flex');
  // } else {
  //   console.log("itineraryQueue NOT", componentValues.itineraryQueue.length);
  //   $('.tripmodal__save-bottom').css('display', 'none');
  //   $target.removeClass('show');
  // }
}

// Create a-new-trip button function
async function onClickCreate(e) {
  const $target = $(e.currentTarget)
  // Show Added Overlay
  if ($target.find('.trip-card-overlay.show').length > 0) {
    $target.find('.trip-card-overlay').removeClass('show');
  } else {
    $target.find('.trip-card-overlay').addClass('show');
  }

  // const found = componentValues.itineraryQueue.indexOf(id); // find position of item in array
  const newTripId = '00000000-0000-0000-0000-000000000000';
  alterItinerariesQueue(newTripId, $target);
  // componentValues.itineraryQueue.push('00000000-0000-0000-0000-000000000000');
}


function alterItinerariesQueue(tripId, evtTarget) {
  // find id in array, if exists remove, else add
  const found = componentValues.itineraryQueue.indexOf(tripId); // find position of item in array

  if (found > -1) {
    componentValues.itineraryQueue.splice(found, 1); // remove item from array
  } else {
    componentValues.itineraryQueue.push(tripId);
  }

  if (componentValues.itineraryQueue < 1) {
    $('.tripmodal__save-bottom').css('display', 'none');
    evtTarget.removeClass('show');
  } else {
    $('.tripmodal__save-bottom').css('display', 'flex');
  }
}




async function openModalForItinerary(payload) {
  if (!payload || !Array.isArray(payload.days) || payload.days.length === 0) {
    return;
  }

  // Clear any stale product-card modal state so it can't leak into this itinerary flow.
  componentValues.productDetails = [];
  sessionStorage.removeItem('modalOpen_Add');
  sessionStorage.removeItem('modalOpen_Add_Products');

  componentValues.itineraryPayload = payload;

  // Check what tpMode we are in and if we need to sign in
  if (isMode('')) {
    const answer = await messageBoxAnswerWait();
    if (!answer) {
      // Declined — don't leave a pending payload that would resume later.
      componentValues.itineraryPayload = null;
      return;
    }
  }

  if (isMode(TripPlannerMode.sandbox)) {
    await askForItineraries().then(() => {
      drawModalTrips(window.usersTrips);
      $('#addToTripModal').modal('show');
    });
    return;
  }

  const token = checkUserToken();

  if (token === null) {
    sessionStorage.removeItem('signinPageVisited');
    // Persist only on the redirect path so it survives the auth round-trip for resume;
    // sandbox and already-logged-in paths don't redirect, so they must not strand it.
    sessionStorage.setItem('pendingItineraryPayload', JSON.stringify(payload));
    const { oidcUserManager, token: refreshedToken } = await startTokenOrSignin();

    if (refreshedToken) {
      localStorage.setItem('user_token', refreshedToken);
      $('#addToTripModal').modal('show');
      initModal();
    }
  } else {
    $('#addToTripModal').modal('show');
    initModal();
  }
}


export { componentValues, initAddToTripCardBtnListeners, initModal, openModalLogic, openModalForProducts, openModalForItinerary, signOut, closeModal, getProduct, getProducts, runAnalyticsAction };
